'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FundShareTakeAction = require('./FundShareTakeAction.css');

var _FundShareTakeAction2 = _interopRequireDefault(_FundShareTakeAction);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'

var FundShareTakeAction = (_dec = (0, _reactCssModules2.default)(_FundShareTakeAction2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundShareTakeAction, _Component);

  function FundShareTakeAction(props) {
    (0, _classCallCheck3.default)(this, FundShareTakeAction);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundShareTakeAction.__proto__ || (0, _getPrototypeOf2.default)(FundShareTakeAction)).call(this, props));

    _this.renderTakeAction = function (shareClass) {
      function renderAction(info, button, link, log) {
        return _react2.default.createElement(
          'div',
          { styleName: 'take-action-action' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-info' },
            info
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-button-wrap' },
            _react2.default.createElement(
              _.Link,
              {
                to: link,
                log: log,
                title: button },
              _react2.default.createElement(
                'div',
                { styleName: 'take-action-button' },
                button,
                ' ',
                _react2.default.createElement('i', { className: 'fa fa-angle-double-right' })
              )
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'take-action-wrap' },
        _react2.default.createElement('div', { styleName: 'take-action-anchor', id: 'take-action' }),
        _react2.default.createElement(
          'div',
          { styleName: 'take-action' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-inner' },
            renderAction('Ask your employer about gender-lens investing in your retirement plan', 'Use our toolkit', _config2.default.routes.toolkit, _analytics2.default.eventToToolkit()),
            renderAction('Find socially responsible funds that invest in gender equality', 'Find top-scoring funds', _config2.default.routes.clean),
            renderAction('Learn more about As You Sow\'s Invest Your Values program', 'Invest Your Values', _config2.default.links.aysinvest),
            renderAction('Visit Fossil Free Funds to measure the climate risk of this portfolio', 'See climate risk', _config2.default.links.fffFund + '/' + shareClass.fund_id + '/' + shareClass.investment_vehicle_id, _analytics2.default.eventToFFF(shareClass.fund_id, shareClass.investment_vehicle_id))
          )
        )
      );
    };

    return _this;
  }

  (0, _createClass3.default)(FundShareTakeAction, [{
    key: 'render',
    value: function render() {
      var shareClass = this.props.shareClass;
      var fund = this.props.fund;
      var url = this.props.url;
      // <Link to={config.links.speakout} bigbutton={true}>Take Action</Link>

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_.Returns, {
          fund: fund,
          shareClass: shareClass,
          url: url
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'holdings-count' },
          _react2.default.createElement(
            'div',
            { styleName: 'holdings-count-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'holdings-count-social' },
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-headline' },
                'What\'s next?'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-intro' },
                'Learn how to make a change and move your money'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-intro' },
                'Get started with our action toolkit'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-button' },
                _react2.default.createElement(
                  _.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    primarybutton: true,
                    title: 'Fossil free action toolkit' },
                  'Action toolkit',
                  _react2.default.createElement(_.LinkIcon, null)
                )
              )
            )
          )
        ),
        this.renderTakeAction(shareClass),
        _react2.default.createElement(
          'div',
          { styleName: 'banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(_.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return FundShareTakeAction;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired,
  shareClass: _react.PropTypes.object.isRequired,
  url: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = FundShareTakeAction;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FundShareTakeAction/FundShareTakeAction.js
// module id = 1295
// module chunks = 0